export const Regex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g